
import * as React from "react"
import { isNativeApp } from "@/utils/platformUtils"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    const isNative = isNativeApp();
    const isSmallScreen = window.innerWidth < MOBILE_BREAKPOINT;
    return isNative || isSmallScreen;
  })

  React.useEffect(() => {
    const checkIsMobile = () => {
      const isNative = isNativeApp();
      const isSmallScreen = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(isNative || isSmallScreen);
    }

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    mql.addEventListener("change", checkIsMobile)
    window.addEventListener("resize", checkIsMobile)
    window.addEventListener("orientationchange", checkIsMobile)

    checkIsMobile()

    return () => {
      mql.removeEventListener("change", checkIsMobile)
      window.removeEventListener("resize", checkIsMobile)
      window.removeEventListener("orientationchange", checkIsMobile)
    }
  }, [])

  return !!isMobile
}

// Simple sidebar state management
const SIDEBAR_COOKIE_NAME = "sidebar:state"
const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7

export function useSidebar() {
  const [isCollapsed, setIsCollapsed] = React.useState(() => {
    if (typeof document === 'undefined') return false;
    
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(`${SIDEBAR_COOKIE_NAME}=`)) {
        return cookie.substring(`${SIDEBAR_COOKIE_NAME}=`.length) === 'true';
      }
    }
    return false;
  });

  const toggle = React.useCallback(() => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    document.cookie = `${SIDEBAR_COOKIE_NAME}=${newState}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
  }, [isCollapsed]);

  return {
    isCollapsed,
    setIsCollapsed,
    toggle
  };
}
